/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInner } from './FindAllScreenerTags200ResponseDataInner';
import {
    FindAllScreenerTags200ResponseDataInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerToJSON,
    FindAllScreenerTags200ResponseDataInnerToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInner';

/**
 * 
 * @export
 * @interface BulkUpdateScreenerTagsRequest
 */
export interface BulkUpdateScreenerTagsRequest {
    /**
     * 
     */
    tags: Array<FindAllScreenerTags200ResponseDataInner>;
}

/**
 * Check if a given object implements the BulkUpdateScreenerTagsRequest interface.
 */
export function instanceOfBulkUpdateScreenerTagsRequest(value: object): value is BulkUpdateScreenerTagsRequest {
    if (!('tags' in value) || value['tags'] === undefined) return false;
    return true;
}

export function BulkUpdateScreenerTagsRequestFromJSON(json: any): BulkUpdateScreenerTagsRequest {
    return BulkUpdateScreenerTagsRequestFromJSONTyped(json, false);
}

export function BulkUpdateScreenerTagsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateScreenerTagsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tags': ((json['tags'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerFromJSON)),
    };
}

export function BulkUpdateScreenerTagsRequestToJSON(json: any): BulkUpdateScreenerTagsRequest {
    return BulkUpdateScreenerTagsRequestToJSONTyped(json, false);
}

export function BulkUpdateScreenerTagsRequestToJSONTyped(value?: BulkUpdateScreenerTagsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tags': ((value['tags'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerToJSON)),
    };
}

